var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 39,
    viewBox: "0 0 40 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3594_46777)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.6945 10.2384L29.3534 7.98633L20.0719 16.9148L10.7904 7.98633L8.44922 10.2384L17.7307 19.1669L8.44922 28.0954L10.7904 30.3474L20.0719 21.419L29.3534 30.3474L31.6945 28.0954L22.413 19.1669L31.6945 10.2384Z",
    fill: "#FF4C4C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3594_46777"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39.8491,
    height: 38.3333,
    fill: "white",
    transform: "translate(0.148438)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.5649482501289cd6f02da8d72b22b00a.svg";
export { ForwardRef as ReactComponent };